import { Modal, Button, Group, Stack, Text } from '@mantine/core'

export default function AlertModal(props) {

    const { opened, onClose, text, okText = 'OK', onOk, ...rest } = props

    const handleOk = () => {
        // If there's a custom onOk callback, call it
        if (onOk) {
            onOk()
        }
        // Always close the modal
        onClose()
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Alert"
            centered
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }
            }}
        >
            <Stack gap="md" style={{ marginTop: '1em' }}>
                <Text>{text}</Text>

                <Group justify="flex-end" mt="xs">
                    <Button onClick={handleOk}>
                        {okText}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}